import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class AthleteService {
  constructor() {
    this.endpoints = createPrefix('/athlete', {
      athletes: '/athletes',
      athletesSearch: '/athletes/search',
      athlete: (id) => `/athlete/${id}`,
    })
  }

  static create() {
    return new AthleteService()
  }

  async get(id) {
    const servicePath = this.endpoints.athlete(id)
    const { data } = await axios.get(servicePath)
    return data
  }

  async query(params) {
    const servicePath = this.endpoints.athletes()
    const { data } = await axios.get(servicePath, { params })
    return data
  }
}
